export const WORLD_NAMES = [
  "스카니아", "베라", "루나", "제니스", "크로아",
  "유니온", "엘리시움", "이노시스", "레드", "오로라",
  "아케인", "노바", "리부트", "리부트2", "버닝", "버닝2", "버닝3"
] as const;

export type worldName = typeof WORLD_NAMES[number];
